import { Navigate, Route, Routes } from 'react-router-dom';
import ContentApprovalsPage from './pages/ContentApprovalsPage';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Reset from './pages/Reset';
import Setup from './pages/Setup';
import WhatsNew from './pages/WhatsNew';
import ImpersonationBanner from './components/ImpersonationBanner';
import ApiCreditBanner from './components/ApiCreditBanner';
import ToastContainer from './components/Toast';
import { useAuth } from './hooks/useAuth';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();
  if (isLoading) {
    return (
      <div className="auth-loading">
        <div className="spinner" />
        <span>Loading…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return (
    <>
      <ImpersonationBanner />
      <ApiCreditBanner />
      {children}
    </>
  );
}

function PublicOnlyRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();
  if (isLoading) {
    return (
      <div className="auth-loading">
        <div className="spinner" />
        <span>Loading…</span>
      </div>
    );
  }
  if (user) return <Navigate to="/" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <>
      <Routes>
        <Route
          path="/login"
          element={
            <PublicOnlyRoute>
              <Login />
            </PublicOnlyRoute>
          }
        />
        <Route path="/setup" element={<Setup />} />
        <Route path="/reset" element={<Reset />} />
        <Route
          path="/content-approvals"
          element={
            <ProtectedRoute>
              <ContentApprovalsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/whats-new"
          element={
            <ProtectedRoute>
              <WhatsNew />
            </ProtectedRoute>
          }
        />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
      <ToastContainer />
    </>
  );
}
